<section class="ib-switch-sell">
    <header class="ib-switch-sell__header">
        <div class="ib-switch-sell__header__content">
            <h1 class="ib-switch-sell__header__content__title">{{'ALP_SWITCH_SELL_TITLE'|translate}}</h1>
            <p class="ib-switch-sell__header__content__description">
                {{'ALP_SWITCH_SELL_SUBTITLE'|translate}}
            </p>
        </div>
        <p class="ib-switch-sell__header__info">
            <span class="ib-switch-sell__header__info__label">{{'ALP_SWITCH_SELL_OUTBOUND_TXT'|translate}}</span>
            {{dateFlight}}

            <ng-container *ngIf="dateReturnFlight">
                <span class="ib-switch-sell__header__info__label"> - {{'ALP_SWITCH_SELL_RETURN_TXT'|translate}}</span>
                {{ dateReturnFlight }}
            </ng-container>

            - {{ numberOfPassengers + ' ' + (numberOfPassengers >= 2 ?
            ('GENERAL_LABEL_PASSENGERS' | translate) : ('GENERAL_LABEL_PASSENGER' |
            translate)) }}


    </header>



    <section class="ib-switch-sell__main">

        <section class="ib-switch-sell__main__section">
            <ib-switch-sell-hotel-card *ngIf="switchSellHotelData"></ib-switch-sell-hotel-card>
            <ib-switch-sell-hotel-card-no-dispo *ngIf="!switchSellHotelData"></ib-switch-sell-hotel-card-no-dispo>
        </section>
        <section class="ib-switch-sell__main__section">
            <ib-switch-sell-car-card *ngIf="switchSellCarData"></ib-switch-sell-car-card>
            <ib-switch-sell-car-card-no-dispo *ngIf="!switchSellCarData"></ib-switch-sell-car-card-no-dispo>
        </section>
    </section>

</section>